var React = require('react');

function Bang2 (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("path",{"className":"st0","d":"M336.4,275.3L210.2,496.8l54.6,31.1l87.8-154.1c0,0,0,0,0,0l33.6-59C373,300.1,356.5,286.8,336.4,275.3","key":1})]);
}

Bang2.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 612 792","style":{"enableBackground":"new 0 0 612 792"},"xmlSpace":"preserve"};

module.exports = Bang2;

Bang2.default = Bang2;
